<template>
  <wh-popup
    v-model="myVisible"
    :ref-form="$refs.ProductPopup"
    title="产品信息"
    @close="hidePopup"
    @open="open"
  >
    <van-form
      ref="ProductPopup"
      class="product-popup"
      label-width="60px"
      @submit="submitForm"
    >
      <div class="img">
        <wh-upload v-model="form.productPhoto" :max-count="1" :size="140" class="upload" />
      </div>
      <div class="list">
        <van-cell :value="form.productName" is-link title="产品名称" @click="editName(form.productName)" />
        <van-cell :value="unit" is-link title="包装规格" @click="$toast('此处包装规格不能修改')" />
        <van-cell
          :value="formatTime(form.packingTime,'YYYY-MM-DD')"
          is-link
          title="生产日期"
          @click="$toast('此处生产日期不能修改')"
        />
        <van-cell
          :value="time"
          is-link
          title="保质期"
          @click="$toast('此处保质期不能修改')"
        />
      </div>
    </van-form>
    <van-dialog
      v-model="dialog.edit.visible"
      data-name="产品名称"
      show-cancel-button
      title="产品名称"
      @confirm="form.productName = dialog.edit.name"
    >
      <div class="dialog-input">
        <van-field v-model="dialog.edit.name" :clearable="true" border placeholder="请输入产品名称" />
      </div>
    </van-dialog>
  </wh-popup>
</template>
<script>
import WhUpload from '@/components/public/WhUpload/WhUpload'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { formatTime } from '@/utils/convert/convertTime'
import { formPopup } from '@/utils/mixins/formPopup'

export default {
  components: { WhPopup, WhUpload },
  mixins: [formPopup],
  data() {
    return {
      dialog: {
        edit: {
          visible: false,
          name: ''
        }
      },
      form: {
        productName: '',
        productPhoto: [],
        specificationPacking: '',
        specificationQuantity: '',
        specificationUint: '',
        packingTime: ''
      }
    }
  },
  computed: {
    unit() {
      return `${this.form.specificationQuantity}${this.form.specificationUint}/${this.form.specificationPacking}`
    },
    time() {
      return `${this.initFormData.QGPTime}${this.initFormData.QGPUnit === '月' ? '个月' : this.initFormData.QGPUnit}`
    }
  },
  methods: {
    formatTime,
    open() {
      this.formDataInit(this.form, this.initFormData)
    },
    submitForm() {
      this.$emit('confirm', this.form)
      this.hidePopup()
    },
    editName(i) {
      this.dialog.edit.visible = true
      this.dialog.edit.name = i
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .van-cell.van-field {
  padding: 6px;
  border: 2px solid #ccc;
  border-radius: 6px;
}
.product-popup {
  padding: 10px 16px;
  .img {
    height: 240px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .list {
    padding-top: 20px;
  }
}
.dialog-input {
  margin: 0 20px;
}
</style>
